import { withStyles } from "@material-ui/core/styles/";
import { TextField } from "@material-ui/core";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";

const BTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "#be9a7b",
    },
    "& label.MuiInputLabel-shrink": {
      color: "#be9a7b",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#be9a7b",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#be9a7b",
      },
      "&:hover fieldset": {
        borderColor: "#be9a7b",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#be9a7b",
      },
    },
  },
})(TextField);

const DPicker = withStyles({
  MuiPickersToolbar: {
    toolbar: {
      backgroundColor: "#8bc34a",
    },
  },
})(MuiPickersUtilsProvider);

const DPickerIn = withStyles({
  root: {
    "& label": {
      color: "#be9a7b",
    },
    "& label.Mui-focused": {
      color: "#be9a7b",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#be9a7b",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#be9a7b",
      },
      "&:hover fieldset": {
        borderColor: "#be9a7b",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#be9a7b",
      },

      // "& MuiPickersCalendarHeader": {
      //   "& switchHeader": {
      //     backgroundColor: "white",
      //     color: "#ffffff",
      //   },
      // },
    },
  },
})(KeyboardDatePicker);
export { BTextField, DPickerIn, DPicker };
